export default "__VITE_ASSET__CHY7LfZT__"